// extracted by mini-css-extract-plugin
module.exports = {"tip-container":"toolTip_tip-container__cO52U"};